;!function(){try{var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import clsx from 'clsx'
import React, { forwardRef } from 'react'

type TextProps = React.ComponentPropsWithoutRef<'div'> & {
  size?: 'md' | 'lg'
}

export const Text = forwardRef(function Text(
  { className, size = 'md', ...props }: TextProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  return (
    <div
      ref={ref}
      data-slot="text"
      {...props}
      className={clsx(
        size === 'md' && 'text-base/7',
        size === 'lg' && 'text-lg/8',
        'text-mist-700 dark:text-mist-400',
        className,
      )}
    />
  )
})
